import React from "react";
import { Alert, Button, Space } from "antd";
import moment from "moment";
import { BatchJob } from "reducers/types";

interface Props {
  job: BatchJob | null;
  providerName: string;
  onApprove: () => void;
  onCancel: () => void;
}

const time = (ms?: number | null) => (ms ? moment(ms).format("HH:mm") : "–");

// In-card notice for the two waiting states (also the fallback when the approval modal was closed).
const JobWaitBanner: React.FC<Props> = ({ job, providerName, onApprove, onCancel }) => {
  if (!job) {
    return null;
  }
  if (job.status === "AWAITING_APPROVAL") {
    return (
      <Alert
        type="warning"
        showIcon
        message={`${providerName} is unavailable — run when it is available?`}
        description={job.waitReason || undefined}
        action={
          <Space direction="vertical">
            <Button size="small" type="primary" onClick={onApprove}>
              Run when available
            </Button>
            <Button size="small" danger onClick={onCancel}>
              Cancel job
            </Button>
          </Space>
        }
      />
    );
  }
  if (job.status === "WAITING_FOR_PROVIDER") {
    return (
      <Alert
        type="info"
        showIcon
        message={`Waiting for ${providerName} — last check ${time(job.lastHealthCheckAt)}, next check ${time(
          job.nextHealthCheckAt,
        )}`}
        action={
          <Button size="small" danger onClick={onCancel}>
            Cancel job
          </Button>
        }
      />
    );
  }
  return null;
};

export default JobWaitBanner;
